import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";

const UpdateMaterialConsumptionVal = ({
  selectedRowsData,
  updateHandleChange,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const productName = selectedRowsData.productName?.size || "";

  const materialName = selectedRowsData.raw_material?.material_name || "";
  const companyName = selectedRowsData.companyDetails?.company_name || "";
  const companyLocation = selectedRowsData.companyDetails?.location || "";
  const companyId = selectedRowsData.companyDetails?.id || "";

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const updateData = async (e) => {
    e.preventDefault();
    const { id, value, material_id, product_id, company_id } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/mat-consumption/material-consumption/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        value,
        material_id,
        product_id,
        company_id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Material Consumption Value
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update Party Name</h4> */}
                    <form className="form-sample" onSubmit={updateData}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Value">Value</label>
                            <input
                              type="number"
                              className="form-control"
                              name="value"
                              id="Value"
                              placeholder="Value"
                              onChange={updateHandleChange}
                              value={selectedRowsData.value}
                              required
                              min="0"
                              step="0.001" // Adjust step value according to the precision you need
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Product">Product Name</label>

                            <input
                              type="text"
                              className="form-control"
                              name="product_name"
                              id="Product"
                              placeholder="Product Name"
                              readOnly
                              value={productName}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Material_name">Material Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="material_name"
                              id="Material_name"
                              placeholder="Material Name"
                              readOnly
                              value={materialName}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Company_Name">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              id="Company_Name"
                              placeholder="company Name"
                              readOnly
                              value={`${companyName}, ${companyLocation}`}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateData}
                      >
                        Update
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateMaterialConsumptionVal;
